<template>
    <div>
        <v-autocomplete
            @keyup="setSearch"
            :value="value"
            @change="handleSelect"
            @click:clear="clearFilter"
            :label="$t('appointment.adminActions.changeHost.selectHost')"
            :no-data-text="$t('appointment.filters.noData')"
            :loading="isFilterLoading"
            :items="searchTextHosts"
            hide-details="auto"
            item-text="name"
            item-value="id"
            return-object
            hide-no-data
            clearable
            outlined
            :dense="dense"
        />
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import HAutocomplete from '@/components/app/HAutocomplete'
export default {
    name:"HostSelect",
    components: {
        HAutocomplete
    },
    props: {
        label: {
            type: String,
        },
        rules: {
            type: Array,
        },
        value: Object,
        dense: {
            default: true,
            required: false,
            type: Boolean
        },
        // Hide hosts blacklisted by the real estate of this appointment / of any appointment of this group
        notBlockedForAppointmentId: {
            type: String,
            default: null,
        },
        notBlockedForGroupId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isFilterLoading: false,
            _timer: null,
        }
    },
    computed: {
        ...mapGetters(['searchTextHosts']),

        hasBlacklistFilter() {
            return Boolean(this.notBlockedForAppointmentId || this.notBlockedForGroupId)
        },
    },
    mounted() {
        this.fetchHostsBySearchText("")
    },
    methods: {
        ...mapActions(['fetchHostsBySearchText']),
        ...mapMutations(['setSearchTextHosts']),

        handleSelect(value) {
          this.$emit('input', value)
        },

        setSearch({ target }) {
            clearTimeout(this._timer)
            this.isFilterLoading = true
            // The results are shared store state: drop the previous search so a host blacklisted
            // here can't be picked from a list fetched for another service
            if (this.hasBlacklistFilter) this.setSearchTextHosts([])

            this._timer = setTimeout(() => {
              this.fetchHostsBySearchText({
                text: target.value,
                notBlockedForAppointmentId: this.notBlockedForAppointmentId,
                notBlockedForGroupId: this.notBlockedForGroupId,
              }).finally(() => this.isFilterLoading = false )
            }, 1000)
        },
        clearFilter() {
            this.isFilterLoading = false
            this.setSearchTextHosts([])
        },
    },
}
</script>
